import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Product } from '../../types/product';
import { ProductCard } from './ProductCard';
type ProductSectionProps = {
  title: string;
  subtitle?: string;
  link?: {
    to: string;
    label: string;
  };
  products: Product[];
};
export function ProductSection({
  title,
  subtitle,
  link,
  products
}: ProductSectionProps) {
  return <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-344" data-mp="37e31115mkrqz">
      <div className="mb-10 flex items-end justify-between gap-6" data-id="element-345" data-mp="3cburrruja7tl">
        <div data-id="element-346" data-mp="3ca1tp0xzkvx7">
          <h2 className="text-4xl font-semibold tracking-display text-ink sm:text-5xl" data-id="element-347" data-mp="2xevpmjigb76i">{title}</h2>
          {subtitle && <p className="mt-2 text-muted" data-id="element-348" data-mp="32dotdk7xrjth">{subtitle}</p>}
        </div>
        {link && <Link to={link.to} className="group hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-ink sm:inline-flex" data-id="element-349" data-mp="1lzov0doqo28c">
            {link.label}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-350" data-mp="1nojkkysa2uu1" />
          </Link>}
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4 lg:gap-x-6" data-id="element-351" data-mp="1irb370eyeutu">
        {products.map(p => <li key={p.slug} data-id="element-352" data-mp="1wner6bz8i6xv">
            <ProductCard product={p} data-id="element-353" data-mp="1rqodtwetdpg5" />
          </li>)}
      </ul>
      {link && <Link to={link.to} className="mt-10 flex h-12 items-center justify-center rounded-full border border-ink text-sm font-medium sm:hidden" data-id="element-354" data-mp="26np4rxp6lgdk">
          {link.label}
        </Link>}
    </section>;
}